// Hardcoded expiry date - this is currently always fixed and not used in the current flow, but required on the endpoint request.
export const FIXED_EXPIRY_DATE = '4925';

export const CREDIT_TRANSACTION_TYPES = ['reload', 'refund', 'transfer_in', 'activation'];
